// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'ed72ba4b';
